import constants from '../constants/app-constants.js'
import EventEmitter from 'events'
import dispatcher from '../dispatcher/dispatcher.js'
import cartasBase from '../util/cartas.js'

class AppStore extends EventEmitter {
    constructor() {
        super();
        this.portugues = {
            LINGUA: 'POR',
            inicio: 'Início',
            minhasHistorias: 'Minhas Histórias',
            sair: 'Sair',
            historia: 'História',
            avancar: 'Avançar',
            voltar: 'Voltar',
            cartaInicial: 'Carta Inicial',
            embaralhando: 'Embaralhando e distribuindo as cartas. Aguarde...',
            sobre: 'Sobre essa carta',
            conte: 'Conte a história',
            terminar: 'Terminar',
            acoes: 'Ações',
            objetos: 'Objetos',
            qualidades: 'Qualidades',
            lugares: 'Lugares',
            personagens: 'Personagens',
            tenteOutra: 'Não há mais cartas desta categoria! Tente outra',
            autorizacao: 'Autorização',
            lido: 'Li e Autorizo',
            nomeHistoria: 'Nome da História',
            guardar: 'Guardar',
            erroEmail: 'Email deve conter o caracter @',
            autores: 'Autores separados por vírgulas',
            email: 'Email',
            ddd: 'DDD',
            telefone: 'Telefone',
            doar: 'Doar',
            escolhaQuantidadeJogadores: 'Escolha a Quantidade de Jogadores',
            escolhaQuantidadeCartas: 'Escolha a Quantidade de Cartas',
            quantidade: 'Quantidade',
            jogador: 'Jogador',
            escolhaTres: 'Escolha até 3 cartas',
            desejaDoar: 'Deseja doar a sua história?',
            sim: 'Sim',
            nao: 'Não',
            mudarNomeJogador: 'Mudar o nome do Jogador',
            clicarNomeJogador: 'Clique no nome para alterá-lo',   
            desejaGuardar: 'Deseja guardar a sua história?',    
            digitacaoObrigatoria: 'Este campo é obrigatório',
            somenteNumeros: 'Permitidos Somente números',
            obrigatoriosdoisdig: 'Campo deve ter 2 dígitos',
            obrigatoriosoitoounovedig: 'Campo deve ter 8 ou 9 dígitos',
        };
        this.ingles = {
            LINGUA: 'ENG',
            inicio: 'Start',
            minhasHistorias: 'My Stories',
            sair: 'Exit',
            historia: 'Story',   
            avancar: 'Next',
            voltar: 'Previous',    
            cartaInicial: 'First Card',
            embaralhando: 'Shuffling and distributing the cards. Please wait...',  
            sobre: 'About this card',
            conte: 'Tell the story',     
            terminar: 'Finish', 
            acoes: 'Actions',
            objetos: 'Objects',
            qualidades: 'Qualities',
            lugares: 'Places',
            personagens: 'Characters', 
            tenteOutra: 'No more cards on this category! Try another',   
            autorizacao: 'Authorization',
            lido: 'Read and authorize', 
            nomeHistoria: 'Story Name',
            guardar: 'Save',   
            erroEmail: 'character @ missing',   
            autores: 'Authors separated by comas',
            email: 'Email',
            ddd: 'DDD',
            telefone: 'Fone',     
            doar: 'Donate',  
            escolhaQuantidadeJogadores: 'Select the number of players',
            escolhaQuantidadeCartas: 'Select the number of cards',
            quantidade: 'Quantity',   
            jogador: 'Player',  
            escolhaTres: 'Select up to 3 cards',    
            desejaDoar: 'Do you want to donate your story?',  
            sim: 'Yes',
            nao: 'No',
            mudarNomeJogador: 'Change the name of the player',
            clicarNomeJogador: 'Click on the name to change it',
            desejaGuardar: 'Do you want to save your story?', 
            digitacaoObrigatoria: 'This field is mandatory',
            somenteNumeros: 'Only numbers allowed',
            obrigatoriosdoisdig: '2 digits mandatory',
            obrigatoriosoitoounovedig: '8 or 9 digits mandatory',            
        };
        this.legendas = this.portugues;

        this.qtdJogadores = 2;
        this.cartas = [];
        this.sequenciaCartas = [];
        this.sequenciaHistorias = [];
        this.sequenciaNumero = 0;
        this.jogadorAtual = 0;
        this.carta1 = cartasBase[0];
        this.cartaX = cartasBase[0];
        this.preparado = false;
        this.qtdCartas = 10;
        this.nomesJogadores = [
            "dummy",
            "Jogador 1",
            "Jogador 2",
            "Jogador 3",
            "Jogador 4",
            "Jogador 5",
            "Jogador 6",
            "Jogador 7",
            "Jogador 8",
            "Jogador 9",
            "Jogador 10",
            "Jogador 11",
            "Jogador 12",
            "Jogador 13",
            "Jogador 14",
            "Jogador 15",
        ]


        this.getSequenciaNumero = this.getSequenciaNumero.bind(this);
        this.getSequenciaCartas = this.getSequenciaCartas.bind(this);
        this.getSequenciaHistorias = this.getSequenciaHistorias.bind(this);

        this.iniciaHistoria = this.iniciaHistoria.bind(this);
        this.incrementaSequenciaNumero = this.incrementaSequenciaNumero.bind(this);
        this.setSequenciaCarta = this.setSequenciaCarta.bind(this);
        this.setSequenciaHistoria = this.setSequenciaHistoria.bind(this);

        this.getQtdJogadores = this.getQtdJogadores.bind(this);
        this.setQtdJogadores = this.setQtdJogadores.bind(this);
        this.getQtdCartas = this.getQtdCartas.bind(this);
        this.setQtdCartas = this.setQtdCartas.bind(this);
        this.getJogadorAtual = this.getJogadorAtual.bind(this);
        this.proximoJogadorAtual = this.proximoJogadorAtual.bind(this);
        this.addChangeQtdJogListener = this.addChangeQtdJogListener.bind(this);
        this.removeChangeQtdJogListener = this.removeChangeQtdJogListener.bind(this);
        this.addChangeQtdCartasListener = this.addChangeQtdCartasListener.bind(this);
        this.removeChangeQtdCartasListener = this.removeChangeQtdCartasListener.bind(this);
        this.addChangeCarta1Listener = this.addChangeCarta1Listener.bind(this);
        this.removeChangeCarta1Listener = this.removeChangeCarta1Listener.bind(this);
        this.addChangeCartaXListener = this.addChangeCartaXListener.bind(this);
        this.removeChangeCartaXListener = this.removeChangeCartaXListener.bind(this);
        this.embaralha = this.embaralha.bind(this);
        this.limita = this.limita.bind(this);
        this.distribui = this.distribui.bind(this);
        this.action = this.action.bind(this);
        this.preparaJogo = this.preparaJogo.bind(this);
        this.getCarta1 = this.getCarta1.bind(this);
        this.getCartaX = this.getCartaX.bind(this);
        this.getCartas = this.getCartas.bind(this);
        this.setNomeJogador = this.setNomeJogador.bind(this);
        this.addChangeNomeJogadorListener = this.addChangeNomeJogadorListener.bind(this);
        this.removeChangeNomeJogadorListener = this.removeChangeNomeJogadorListener.bind(this);
        this.mudaIngles = this.mudaIngles.bind(this);
        this.mudaPortugues = this.mudaPortugues.bind(this);
    }



    embaralha() {
        var a = cartasBase.slice(0);
        var len = a.length;
        for (let i = len; i; i--) {
            let j = Math.floor(Math.random() * i);
            var x = a[i - 1];
            a[i - 1] = a[j];
            a[j] = x;
        }
        return a;
    }

    limita(cartas, tamanho) {
        let copia1 = [];
        for (let i = 0; i < tamanho; i++) {
            copia1[i] = cartas[i];
            copia1[i].key = i;
        }
        return copia1;
    }

    distribui(cartas, qtdJogadores) {
        var len = cartas.length;
        let jogador = 0;
        for (let i = 0; i < len; i++) {
            jogador++;

            if (jogador > qtdJogadores) {
                jogador = 1;
            }
            cartas[i].jogador = jogador;
        }
    }

    addChangeLinguaListener(callback) {
        this.on('CHANGELINGUA_EVENT', callback);
    }

    removeChangeLinguaListener(callback) {
        this.removeListener('CHANGELINGUA_EVENT', callback);
    }    

    addChangeNomeJogadorListener(callback) {
        this.on('CHANGENOMEJOGADOR_EVENT', callback);
    }

    removeChangeNomeJogadorListener(callback) {
        this.removeListener('CHANGENOMEJOGADOR_EVENT', callback);
    }

    addChangeCarta1Listener(callback) {
        this.on('CHANGECARTA1_EVENT', callback);
    }

    removeChangeCarta1Listener(callback) {
        this.removeListener('CHANGECARTA1_EVENT', callback);
    }

    addChangeCartaXListener(callback) {
        this.on('CHANGECARTAX_EVENT', callback);
    }

    removeChangeCartaXListener(callback) {
        this.removeListener('CHANGECARTAX_EVENT', callback);
    }

    addChangeQtdJogListener(callback) {
        this.on('CHANGEQTDJOG_EVENT', callback);
    }

    removeChangeQtdJogListener(callback) {
        this.removeListener('CHANGEQTDJOG_EVENT', callback);
    }

    addChangeQtdCartasListener(callback) {
        this.on('CHANGEQTDCARTAS_EVENT', callback);
    }

    removeChangeQtdCartasListener(callback) {
        this.removeListener('CHANGEQTDCARTAS_EVENT', callback);
    }

    addChangeJogAtualListener(callback) {
        this.on('CHANGEJOGATUAL_EVENT', callback);
    }

    removeChangeJogAtualListener(callback) {
        this.removeListener('CHANGEJOGATUAL_EVENT', callback);
    }

    addChangeStatusCartasListener(callback) {
        this.on('CHANGESTATUSCARTAS_EVENT', callback);
    }

    removeChangeStatusCartasListener(callback) {
        this.removeListener('CHANGESTATUSCARTAS_EVENT', callback);
    }

    getNomeJogador() {
        return this.nomesJogadores[this.jogadorAtual];
    }

    getCartas() {
        return this.cartas;
    }

    getJogadorAtual() {
        return this.jogadorAtual;
    }

    getCarta1() {
        return this.carta1;
    }

    getCartaX() {
        return this.cartaX;
    }

    consultaProximoJogadorAtual() {
        let tmp = this.jogadorAtual + 1;
        if (tmp > this.qtdJogadores) {
            tmp = 1;
        }
        return tmp;
    }

    proximoJogadorAtual() {
        this.jogadorAtual++;
        if (this.jogadorAtual > this.qtdJogadores) {
            this.jogadorAtual = 1;
        }
        this.emit('CHANGEJOGATUAL_EVENT');
    }

    getQtdJogadores() {
        return this.qtdJogadores;
    }

    setQtdJogadores(qtd) {
        this.qtdJogadores = qtd;
        this.emit('CHANGEQTDJOG_EVENT');
    }

    getQtdCartas() {
        return this.qtdCartas;
    }

    setQtdCartas(qtd) {
        this.qtdCartas = qtd;
        this.emit('CHANGEQTDCARTAS_EVENT');
    }

    setStatusCartas(cartas) {
        this.cartas = cartas;
        this.emit('CHANGESTATUSCARTAS_EVENT');
    }

    setNomeJogador(nome) {
        this.nomesJogadores[this.jogadorAtual] = nome;
        this.emit('CHANGENOMEJOGADOR_EVENT');
    }

    setCartaX(carta) {
        this.cartaX = carta;
        this.emit('CHANGECARTAX_EVENT');
    }

    preparaJogo() {
        let tmpcartas = this.embaralha();
        //let qtdCartas = this.qtdJogadores * 6;
        //if (this.qtdJogadores > 1 && this.qtdJogadores < 7) {
        //qtdCartas = 36;
        //}
        this.cartas = this.limita(tmpcartas, this.qtdCartas);
        this.carta1 = tmpcartas[this.qtdCartas];
        this.emit('CHANGECARTA1_EVENT');
        this.distribui(this.cartas, this.qtdJogadores);
        this.preparado = true;
    }

    iniciaHistoria() {
        this.sequenciaNumero = 0;
        this.sequenciaCartas = [];
        this.sequenciaHistorias = [];
    }

    incrementaSequenciaNumero() {
        this.sequenciaNumero += 1;
    }

    setSequenciaCarta(id) {
        this.sequenciaCartas[this.sequenciaNumero] = id;
    }

    setSequenciaHistoria(historia) {
        this.sequenciaHistorias[this.sequenciaNumero] = historia;
    }

    getSequenciaNumero() {
        return this.sequenciaNumero;
    }

    getSequenciaCartas() {
        return this.sequenciaCartas;
    }

    getSequenciaHistorias() {
        return this.sequenciaHistorias;
    }

    mudaIngles() {
        this.legendas = this.ingles;
        this.emit('CHANGELINGUA_EVENT');
    }

    mudaPortugues() {
        this.legendas = this.portugues;
        this.emit('CHANGELINGUA_EVENT');
    }

    action({ actionType, payload }) {
        switch (actionType) {
            case constants.MUDAINGLES:
                this.mudaIngles();
                break;
            case constants.MUDAPORTUGUES:
                this.mudaPortugues();
                break;
            case constants.PREPARAJOGO:
                this.preparaJogo();
                break;
            case constants.PROXJOGADOR:
                this.proximoJogadorAtual();
                break;
            case constants.EMBARALHAR:
                break;
            case constants.LIMITAR:
                break;
            case constants.DISTRIBUIR:
                break;
            case constants.QTDJOGADORES:
                this.setQtdJogadores(payload);
                break;
            case constants.QTDCARTAS:
                this.setQtdCartas(payload);
                break;
            case constants.STATUSCARTAS:
                this.setStatusCartas(payload);
                break;
            case constants.NOMEJOGADOR:
                this.setNomeJogador(payload);
                break;
            case constants.CARTAX:
                this.setCartaX(payload);
                break;
            case constants.INICIAHISTORIA:
                this.iniciaHistoria();
                break;
            case constants.SEQUENCIANUMERO:
                this.incrementaSequenciaNumero();
                break;
            case constants.SEQUENCIACARTA:
                this.setSequenciaCarta(payload);
                break;
            case constants.SEQUENCIAHISTORIA:
                this.setSequenciaHistoria(payload);
                break;
            default:
                break;
        }
    }

}

const store = new AppStore();
dispatcher.register(store.action);

export default store;


// WEBPACK FOOTER //
// ./src/stores/app-store.js